// Vendor
import { EventEmitter } from '@angular/core';
// Services
import { HoldingsOverlapService } from '../../../../services/holdings-overlap.service';
// Directives
// Utils & constants
import { ASC, DESC } from 'NewAngular/constants/core.constants';
import { getBasicFormatted, PERCENT } from 'NewAngular/utils/number_formatter';
import { downloadUrl } from 'NewAngular/utils/download';
import * as i0 from "@angular/core";
import * as i1 from "../../../../services/holdings-overlap.service";
import * as i2 from "../../../../../../../../../ycharts/static/ts/features/components/loaders/loading-symbol/loading-symbol.component";
import * as i3 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i4 from "../../../../../../../../../ycharts/static/ts/features/directives/disabled/disabled.directive";
import * as i5 from "@angular/common";
function CommonHoldingsComparisonTableComponent_div_8_tr_22_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelement(1, "td", 26)(2, "td", 26)(3, "td", 27)(4, "td", 27)(5, "td", 27)(6, "td", 27);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const holding_r3 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("textContent", holding_r3.symbol);
    i0.ɵɵadvance();
    i0.ɵɵproperty("textContent", holding_r3.name);
    i0.ɵɵadvance();
    i0.ɵɵproperty("textContent", ctx_r1.formatPercentage(holding_r3.primary_weight));
    i0.ɵɵadvance();
    i0.ɵɵproperty("textContent", ctx_r1.formatPercentage(holding_r3.secondary_weight));
    i0.ɵɵadvance();
    i0.ɵɵproperty("textContent", ctx_r1.formatPercentage(holding_r3.overlap));
    i0.ɵɵadvance();
    i0.ɵɵproperty("textContent", ctx_r1.formatPercentage(holding_r3.difference));
} }
function CommonHoldingsComparisonTableComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9)(1, "div", 10)(2, "table", 11)(3, "thead", 12)(4, "tr", 13)(5, "th", 14);
    i0.ɵɵlistener("click", function CommonHoldingsComparisonTableComponent_div_8_Template_th_click_5_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.setSortColumn("symbol")); });
    i0.ɵɵelementStart(6, "span", 15);
    i0.ɵɵtext(7, " Symbol ");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "th", 16);
    i0.ɵɵlistener("click", function CommonHoldingsComparisonTableComponent_div_8_Template_th_click_8_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.setSortColumn("name")); });
    i0.ɵɵelementStart(9, "span", 15);
    i0.ɵɵtext(10, " Name ");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(11, "th", 17);
    i0.ɵɵlistener("click", function CommonHoldingsComparisonTableComponent_div_8_Template_th_click_11_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.setSortColumn("primary_weight")); });
    i0.ɵɵelement(12, "span", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "th", 19);
    i0.ɵɵlistener("click", function CommonHoldingsComparisonTableComponent_div_8_Template_th_click_13_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.setSortColumn("secondary_weight")); });
    i0.ɵɵelement(14, "span", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "th", 20);
    i0.ɵɵlistener("click", function CommonHoldingsComparisonTableComponent_div_8_Template_th_click_15_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.setSortColumn("overlap")); });
    i0.ɵɵelementStart(16, "span", 15);
    i0.ɵɵtext(17, " Overlap ");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(18, "th", 21);
    i0.ɵɵlistener("click", function CommonHoldingsComparisonTableComponent_div_8_Template_th_click_18_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.setSortColumn("difference")); });
    i0.ɵɵelementStart(19, "span", 15);
    i0.ɵɵtext(20, " Difference ");
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementStart(21, "tbody");
    i0.ɵɵtemplate(22, CommonHoldingsComparisonTableComponent_div_8_tr_22_Template, 7, 6, "tr", 22);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(23, "div", 10)(24, "div", 3)(25, "div", 4)(26, "div", 23);
    i0.ɵɵtext(27);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(28, "div", 4)(29, "span", 24);
    i0.ɵɵlistener("click", function CommonHoldingsComparisonTableComponent_div_8_Template_span_click_29_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.decrementPageNumber()); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(30, "svg", 25);
    i0.ɵɵelementEnd()();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(31, "div", 4)(32, "span", 24);
    i0.ɵɵlistener("click", function CommonHoldingsComparisonTableComponent_div_8_Template_span_click_32_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.incrementPageNumber()); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(33, "svg", 25);
    i0.ɵɵelementEnd()()()()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngClass", ctx_r1.getSortColumnClass("symbol"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", ctx_r1.getSortColumnClass("name"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", ctx_r1.getSortColumnClass("primary_weight"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("textContent", ctx_r1.primaryDisplaySecurityId);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", ctx_r1.getSortColumnClass("secondary_weight"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("textContent", ctx_r1.secondaryDisplaySecurityId);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", ctx_r1.getSortColumnClass("overlap"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", ctx_r1.getSortColumnClass("difference"));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngForOf", ctx_r1.holdings);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate3("Showing ", ctx_r1.paginationInfo.start_index, "-", ctx_r1.paginationInfo.end_index, " of ", ctx_r1.paginationInfo.num_items, " Holdings");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", ctx_r1.paginationInfo.current_page_num === 1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-back");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", ctx_r1.paginationInfo.current_page_num >= ctx_r1.paginationInfo.num_pages);
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-collapse");
} }
function CommonHoldingsComparisonTableComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 28)(1, "span");
    i0.ɵɵtext(2, "No Common Holdings");
    i0.ɵɵelementEnd()();
} }
function CommonHoldingsComparisonTableComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 28)(1, "span");
    i0.ɵɵtext(2, "An error occurred while fetching holdings. Please try again or contact support.");
    i0.ɵɵelementEnd()();
} }
function CommonHoldingsComparisonTableComponent_ycn_loading_symbol_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-loading-symbol", 29);
} }
/**
 * CommonHoldingsComparison Component.
 *
 */
export class CommonHoldingsComparisonTableComponent {
    constructor(holdingsOverlapService) {
        this.holdingsOverlapService = holdingsOverlapService;
        this.setSortProperties = new EventEmitter();
        this.holdings = [];
        // Sorting
        this.sortColumn = 'primary_weight';
        this.sortDirection = DESC;
        this.paginationInfo = { current_page_num: 1, num_pages: 1 };
        this.loading = false;
        this.showNoHoldingsMessage = false;
        this.showErrorMessage = false;
    }
    ngOnInit() {
        this.fetchHoldingsComparison();
    }
    fetchHoldingsComparison() {
        const page = this.paginationInfo.current_page_num;
        this.loading = true;
        this.showNoHoldingsMessage = false;
        this.showErrorMessage = false;
        this.holdingsOverlapService
            .getCommonHoldings(this.primarySecurityId, this.secondarySecurityId, page, this.sortColumn, this.sortDirection, this.holdingsLayer)
            .subscribe({
            next: (rsp) => {
                this.holdings = rsp.holdings_data;
                this.paginationInfo = rsp.pagination_info;
                this.loading = false;
                if (this.holdings.length <= 0) {
                    this.showNoHoldingsMessage = true;
                }
                this.setSortProperties.emit({
                    sortColumn: this.sortColumn,
                    sortDirection: this.sortDirection,
                });
            },
            error: () => {
                this.loading = false;
                this.showErrorMessage = true;
            },
        });
    }
    exportHoldingsComparison() {
        const page = this.paginationInfo.current_page_num;
        const url = this.holdingsOverlapService.getCommonHoldingsComparisonExportUrl(this.primarySecurityId, this.secondarySecurityId, page, this.sortColumn, this.sortDirection, this.holdingsLayer);
        downloadUrl(url);
    }
    formatPercentage(value) {
        if (value == null)
            return '--';
        return getBasicFormatted(value, PERCENT, 2);
    }
    decrementPageNumber() {
        const page_num = this.paginationInfo.current_page_num > 1 ? this.paginationInfo.current_page_num - 1 : 1;
        this.paginationInfo.current_page_num = page_num;
        this.fetchHoldingsComparison();
    }
    incrementPageNumber() {
        const page_num = this.paginationInfo.current_page_num < this.paginationInfo.num_pages
            ? this.paginationInfo.current_page_num + 1
            : this.paginationInfo.num_pages;
        this.paginationInfo.current_page_num = page_num;
        this.fetchHoldingsComparison();
    }
    setSortColumn(columnName) {
        // Same sort column selected. Change sort direction
        if (this.sortColumn === columnName) {
            this.sortDirection = this.sortDirection === DESC ? ASC : DESC;
            this.fetchHoldingsComparison();
        }
        else {
            this.sortColumn = columnName;
            this.sortDirection = DESC;
            this.fetchHoldingsComparison();
        }
    }
    getSortColumnClass(columnName) {
        if (columnName === this.sortColumn) {
            if (this.sortDirection === DESC)
                return 'th-sort-desc';
            if (this.sortDirection === ASC)
                return 'th-sort-asc';
        }
        return '';
    }
}
CommonHoldingsComparisonTableComponent.ɵfac = function CommonHoldingsComparisonTableComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || CommonHoldingsComparisonTableComponent)(i0.ɵɵdirectiveInject(i1.HoldingsOverlapService)); };
CommonHoldingsComparisonTableComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CommonHoldingsComparisonTableComponent, selectors: [["ycn-common-holdings-comparison-table"]], inputs: { primarySecurityId: "primarySecurityId", secondarySecurityId: "secondarySecurityId", primaryDisplaySecurityId: "primaryDisplaySecurityId", secondaryDisplaySecurityId: "secondaryDisplaySecurityId", holdingsLayer: "holdingsLayer" }, outputs: { setSortProperties: "setSortProperties" }, standalone: false, decls: 12, vars: 5, consts: [[1, "panel", "panel-data"], [1, "panel-header"], [1, "panel-title"], [1, "panel-actions"], [1, "panel-action"], [1, "btn", "btn-text", 3, "click", "disabled"], ["class", "panel-scroll", 4, "ngIf"], ["class", "get-started border-0 pt-10", 4, "ngIf"], ["loaderMessage", "Loading Data...", 4, "ngIf"], [1, "panel-scroll"], [1, "panel-content"], [1, "table"], [2, "cursor", "pointer", "user-select", "none"], ["data-test-id", "Column Headers"], ["data-test-id", "symbol-column-header", 1, "colTxtMed", 3, "click", "ngClass"], [2, "padding-top", "0", "padding-bottom", "0"], ["data-test-id", "name-column-header", 1, "col-4", 3, "click", "ngClass"], ["data-test-id", "primary-weight-column-header", 1, "text-right", 3, "click", "ngClass"], [2, "padding-top", "0", "padding-bottom", "0", 3, "textContent"], ["data-test-id", "secondary-weight-column-header", 1, "text-right", 3, "click", "ngClass"], ["data-test-id", "overlap-column-header", 1, "text-right", 3, "click", "ngClass"], ["data-test-id", "difference-column-header", 1, "text-right", 3, "click", "ngClass"], [4, "ngFor", "ngForOf"], [1, "panel-results-count"], ["ycnDisabled", "", 1, "btn", "btn-secondary", 3, "click", "disabled"], ["ycnIcon", "", 3, "name"], [3, "textContent"], [1, "text-right", 3, "textContent"], [1, "get-started", "border-0", "pt-10"], ["loaderMessage", "Loading Data..."]], template: function CommonHoldingsComparisonTableComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "h3", 2);
        i0.ɵɵtext(3, "Table of Common Holdings");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 3)(5, "div", 4)(6, "button", 5);
        i0.ɵɵlistener("click", function CommonHoldingsComparisonTableComponent_Template_button_click_6_listener() { return ctx.exportHoldingsComparison(); });
        i0.ɵɵtext(7, "Export Holdings");
        i0.ɵɵelementEnd()()()();
        i0.ɵɵtemplate(8, CommonHoldingsComparisonTableComponent_div_8_Template, 34, 16, "div", 6)(9, CommonHoldingsComparisonTableComponent_div_9_Template, 3, 0, "div", 7)(10, CommonHoldingsComparisonTableComponent_div_10_Template, 3, 0, "div", 7)(11, CommonHoldingsComparisonTableComponent_ycn_loading_symbol_11_Template, 1, 0, "ycn-loading-symbol", 8);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("disabled", ctx.holdings.length === 0);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", !ctx.loading && !ctx.showErrorMessage && !ctx.showNoHoldingsMessage);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.loading && ctx.showNoHoldingsMessage);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.loading && ctx.showErrorMessage);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.loading);
    } }, dependencies: [i2.LoadingSymbolComponent, i3.IconDirective, i4.DisabledDirective, i5.NgClass, i5.NgForOf, i5.NgIf], encapsulation: 2 });
